<template>
  <BasePopup
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
    :deleteIcon="deleteIcon"
    :deleteButtonLabel="deleteButtonLabel"
    :deleteTitle="deleteTitle"
    :deleteConfirmButtonLabel="deleteConfirmButtonLabel"
    :deleteColor="deleteColor"
    :readOnly="readOnly"
  >
    <p> Você tem certeza que deseja reabrir a venda ?</p>
    
  </BasePopup>
</template>

<script>
import gql from 'graphql-tag';
// import BaseDelete from "@shared_components/base_delete.vue";
import BasePopup from '../../shared/base_popup.vue';

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {    
    BasePopup: BasePopup,
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    deleteIcon: {
      type: String,
      default: "mdi-lock-open-outline",
    },
    deleteColor: {
      type: String,
      default: "warning",
    },
    deleteButtonLabel: {
      type: String,
      default: function() {
        return "Reabrir venda";
      }
    },
    deleteTitle: {
      type: String,
      default: function() {
        return "Reabrir Venda"
      }
    },
    deleteConfirmButtonLabel: {
      type: String,
      default: "Reabrir"
    },
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(sale) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: REOPEN_SALE_MUTATION,
            variables: {
              id: sale.id,
            }
          })
          .then(response => {
            var errors = response.data.reopenSale.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}

const REOPEN_SALE_MUTATION = gql `
  mutation($id: ID!) {
    reopenSale(id: $id) {
      cashFlow {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>
